export default {
  common: {
    loading: "Loading...",
  },
  header: {
    openMenu: "Open menu",
    home: "Home",
    language: "Language",
    searchPlaceholder: "Search a page...",
    searchLabel: "Search a page",
    noResult: "No results found",
    notifications: "Notifications",
    notificationsUnread: "Notifications, {count} unread",
    markAllRead: "Mark all as read",
    noNotifications: "No notifications",
    onlineAccount: "Account online",
    myAccount: "My account",
    myProfile: "My profile",
    profile: "Profile",
    settings: "Settings",
    logout: "Log out",
    roleAdmin: "Admin",
    roleClient: "Client",
    roleDriver: "Driver",
    roleZoneManager: "Zone manager",
    justNow: "Just now",
    minutesAgo: "{n} min ago",
    hoursAgo: "{n} h ago",
  },
  theme: {
    enableLight: "Switch to light mode",
    enableDark: "Switch to dark mode",
    light: "Light mode",
    dark: "Dark mode",
  },
  sidebar: {
    mainNav: "Main navigation",
    mainMenu: "Main menu",
    closeMenu: "Close menu",
    loadingMenu: "Loading menu",
  },
  menu: {
    dashboard: "Dashboard",
    parcels: "Parcels",
    addParcel: "New parcel",
    parcelsList: "Parcel list",
    pickupParcels: "Parcels for pickup",
    followups: "Follow-up & reminders",
    exchanges: "Exchanges",
    importParcels: "Import parcels",
    inventory: "Inventory",
    productsList: "Product list",
    stockParcels: "Stock parcels",
    deliveryNotes: "Delivery notes",
    addDeliveryNote: "New delivery note",
    myInvoices: "My invoices",
    refunds: "Refunds",
    newRequest: "New request",
    myRequests: "My requests",
    balanceHistory: "Balance history",
    returnNotes: "Return notes",
    claims: "Claims",
    pickup: "Pickup",
    users: "Users",
    subAccounts: "Sub-accounts",
    blackList: "Blacklist",
    apiDocs: "API documentation",
    myDocuments: "My documents",
    ribChange: "RIB change",
    phoneChange: "Phone change",
    webhooks: "Webhooks",
    profile: "Profile",
  },
  account: {
    activeAccount: "Active account: {name}",
    switchHint: " — switch account",
    subAccountOf: "Sub-account · {name}",
    mainAccount: "Main account",
    subAccount: "Sub-account",
    inactive: "Inactive",
    switchAccount: "Switch account",
    allAccounts: "All accounts",
    manageSubAccounts: "Manage sub-accounts",
    enterFailed: "Unable to open this account",
  },
};
